function $84ce8bef1b4ff9bb$export$2e2bcd8739ae039({ type: type , title: title , image: image , publishedAt: publishedAt , updatedAt: updatedAt , author: author  } = {
}) {
    // Set defaults and cast vars
    type = type || 'blog';
    return {
        // Make the JSON LD
        '@type': (function() {
            switch(type){
                case 'news':
                    return 'NewsArticle';
                case 'article':
                    return 'Article';
                case 'blog':
                    return 'BlogPosting';
                default:
                    return `Unknown article type ${type}`;
            }
        })(),
        headline: title,
        image: image,
        author: author,
        datePublished: publishedAt != null ? typeof publishedAt.toISOString === "function" ? publishedAt.toISOString() : void 0 : void 0,
        dateModified: updatedAt != null ? typeof updatedAt.toISOString === "function" ? updatedAt.toISOString() : void 0 : void 0
    };
}


function $4f99b21ae4e13d20$export$2e2bcd8739ae039({ name: name , url: url , logo: logo , publishedAt: publishedAt , updatedAt: updatedAt  } = {
}) {
    // Set defaults and cast vars
    name = name || process.env.SITE_NAME;
    url = url || process.env.URL;
    return {
        // Make the JSON LD
        '@type': 'Organization',
        name: name,
        url: url,
        logo: logo
    };
}


function $ad1636893679b75e$export$2e2bcd8739ae039({ name: name , image: image , description: description , sku: sku , brand: brand , url: url , price: price , available: available  } = {
}) {
    var ref;
    // Set defaults and cast vars
    brand = brand || process.env.SITE_NAME;
    return {
        // Make the JSON LD
        '@type': 'Product',
        name: name,
        image: image,
        description: (ref = (function() {
            return description;
        })()) != null ? ref.replace(/<\/?[^>]+(>|$)/g, '').replace(/\s+/g, ' ').trim() : void 0,
        sku: sku,
        brand: {
            '@type': 'Brand',
            name: brand
        },
        offers: {
            '@type': 'Offer',
            url: url,
            priceCurrency: 'USD',
            price: price,
            availability: (function() {
                if (available == null) return;
                if (available) return 'https://schema.org/InStock';
                else return 'https://schema.org/OutOfStock';
            })()
        }
    };
}


function $553204017497ca93$export$2e2bcd8739ae039({ siteName: siteName , siteUrl: siteUrl , urlTemplate: urlTemplate , urlTemplatePlaceholder: urlTemplatePlaceholder  } = {
}) {
    // Set defaults and cast vars
    siteName = siteName || process.env.SITE_NAME;
    siteUrl = siteUrl || process.env.URL;
    urlTemplate = urlTemplate || '/search?q={query}';
    urlTemplatePlaceholder = urlTemplatePlaceholder || 'query';
    return {
        // Make the JSON LD
        '@type': 'Website',
        name: siteName,
        url: siteUrl,
        potentialAction: {
            '@type': 'SearchAction',
            name: siteName + ' Search',
            target: {
                '@type': 'EntryPoint',
                urlTemplate: siteUrl + urlTemplate
            },
            'query-input': `required name=${urlTemplatePlaceholder}`
        }
    };
}


/*
Render the script tag that renders json-ld
*/ var $a56e88318c4367d9$var$makeTag;
var $a56e88318c4367d9$export$8edec034e5425182 = function(props) {
    return $a56e88318c4367d9$var$makeTag($84ce8bef1b4ff9bb$export$2e2bcd8739ae039(props));
};
var $a56e88318c4367d9$export$66bd74c8c00bc085 = function(props) {
    return $a56e88318c4367d9$var$makeTag($4f99b21ae4e13d20$export$2e2bcd8739ae039(props));
};
var $a56e88318c4367d9$export$ed912fd0e21f068e = function(props) {
    return $a56e88318c4367d9$var$makeTag($ad1636893679b75e$export$2e2bcd8739ae039(props));
};
var $a56e88318c4367d9$export$9fa68bface6198c1 = function(props) {
    return $a56e88318c4367d9$var$makeTag($553204017497ca93$export$2e2bcd8739ae039(props));
};
// Wrap the json ld data in the stucture needed by vue meta
$a56e88318c4367d9$var$makeTag = function(data) {
    return {
        type: 'application/ld+json',
        json: {
            '@context': 'http://schema.org',
            ...data
        },
        hid: 'json-ld-' + data['@type'].toLowerCase()
    };
};


export {$a56e88318c4367d9$export$8edec034e5425182 as makeJsonLdArticleTag, $a56e88318c4367d9$export$66bd74c8c00bc085 as makeJsonLdOrganizationTag, $a56e88318c4367d9$export$ed912fd0e21f068e as makeJsonLdProductTag, $a56e88318c4367d9$export$9fa68bface6198c1 as makeJsonLdSearchTag};
//# sourceMappingURL=module.js.map
